'use strict'
global.jQuery = require('jquery');
var _ = require( 'underscore');
var easing = require( 'jquery-easing');
var fitText = require('./vendor/jquery.fittext.js');

/*
================================================================
* javascript information
* file name  : function.js
================================================================
*/
$(function(){
   $(".js−rollover").mouseover(function(){

      /* セレクタがついているかどうかの条件判断はマウスオーバーとマウスアウトのそれぞれに対して設定する。
      マウスオーバー時だけだと、クリックした後、マウスアウトするときに_onが外されて通常時の画像になってしまうため */
      var className = $(this).attr('class');
      if(className!='selected'){
         $("img",this).attr("src",$("img",this).attr("src").replace(/^(.+)(\.[a-z]+)$/, "$1_on$2"))
      }
   }).mouseout(function(){
   var className2 = $(this).attr('class');
      if(className2!='selected'){
         $("img",this).attr("src",$("img",this).attr("src").replace(/^(.+)_on(\.[a-z]+)$/,"$1$2"))
      }
   })
});
